import axios from "axios";

export const getGoogleAccount = async () => {
    const url = `/api/v1/user_profile/google_account`;
    const res = await axios.get(url);
    return res.data;
};

export const createGoogleAccount = async (data) => {
    const url = `/api/v1/user_profile/google_account`;
    const res = await axios.post(url, data);
    return res.data;
};